import { FinishNewsletterPopupProps } from '@husky-x/cc-finish-newsletter-popup/dist/types/models';

export const FinishProductDifferencesMock = {
  header: '<h2>ERFAHREN SIE WIE SICH UNSERE PRODUKTE UNTERSCHEIDEN</h2>',
  borderedImage: true,
  navigationButton: {
    link: '/produkte/',
    label: 'ALLE PRODUKTE ANSEHEN',
  },
  useCheckmark: false,
  tables: [
    {
      title: 'FINISH',
      legend:
        '<ul>\n<li><sup>*</sup>Bei stark verschmutztem Geschirr</li>\n<li><sup>**</sup>vs. Finish Power basierend auf dem Durchschnittsgewicht</li>\n<li><sup>***</sup>Inhaltsstoff: Enzym</li>\n</ul>',
      rows: [
        {
          text: 'Reinigung',
          image:
            'https://eu-images.contentstack.com/v3/assets/blt639569eaa143b45b/blt82888abe65a3cf92/66a8bd75f24439cde173be08/clean.svg',
        },
        {
          text: 'Gland',
          image:
            'https://eu-images.contentstack.com/v3/assets/blt639569eaa143b45b/blt4068f74db0e98470/66a8bdf6b8115e2482a37a72/shine.svg',
        },
        {
          text: 'Entfernt 48h Eingetrocknetes<sup>*</sup>',
          image:
            'https://eu-images.contentstack.com/v3/assets/blt639569eaa143b45b/blt4b1a83960fae2f42/66a8bd75b8115e47cca37a6d/dried-on.svg',
        },
        {
          text: 'Fettlösekraft',
          image:
            'https://eu-images.contentstack.com/v3/assets/blt639569eaa143b45b/bltef4110afe98d3440/66a8bdf6f24439951073be0f/tough-on-grease.svg',
        },
        {
          text: 'Kein Vorspülen',
          image:
            'https://eu-images.contentstack.com/v3/assets/blt639569eaa143b45b/bltb35fc648c6362147/66a8bdf61097ec6bcaa86bf5/skip-the-rinse.svg',
        },
        {
          text: 'Ohne Auspacken',
          image:
            'https://eu-images.contentstack.com/v3/assets/blt639569eaa143b45b/blt906d9e1af7cf7cf8/66a8bd7575e8676dacd73cd9/wrapper-free-tabs.svg',
        },
        {
          text: 'Schnellauflösend',
          image:
            'https://eu-images.contentstack.com/v3/assets/blt639569eaa143b45b/blt84a3d1465f181c87/66a8bdf67da9b43d0cb481c0/fast-dissolving.svg',
        },
        {
          text: 'Weniger Chemikaliengehal<sup>**</sup>',
          image:
            'https://eu-images.contentstack.com/v3/assets/blt639569eaa143b45b/blt0b422bd29369e3e4/66a8bdf6739577514719fa1a/less-chemical-weight.svg',
        },
        {
          text: 'Glasschutz',
          image:
            'https://eu-images.contentstack.com/v3/assets/blt639569eaa143b45b/blta20864530554004a/66a8bd751a892d24844a3ac8/glass-protection.svg',
        },
        {
          text: 'Verleiht mehr Frische',
          image:
            'https://eu-images.contentstack.com/v3/assets/blt639569eaa143b45b/blt95a23ce6c566f108/66a8bd7517cd4f0b596f724a/freshness-boost.svg',
        },
        {
          text: 'Entfernt Eingebranntes effektiv',
          image:
            'https://eu-images.contentstack.com/v3/assets/blt639569eaa143b45b/bltf4e3970c7de0d7ea/66a8bd7506435dc50cddea0b/burnt-on-stains.svg',
        },
        {
          text: 'Richtiger Inhaltsstoff<sup>***</sup> zur richtigen Zeit',
          image:
            'https://eu-images.contentstack.com/v3/assets/blt639569eaa143b45b/blt4228905f1347b8d8/66a8bd75f095557978747345/right-ingredient-right-time-1.png',
        },
      ],
      columns: [
        {
          productImage:
            'https://eu-images.contentstack.com/v3/assets/blt639569eaa143b45b/blt5a1d9e23a9f38b42/66a8bab8f2443983a573bdfc/ultimate-plus-x2.png',
          productName: 'ULTIMATE PLUS',
          productLink: '/produkte/reiniger/ultimate-plus-spuelmaschinentabs/48-regular/',
          color: 'gold-gradient',
          values: [
            {
              value: 5,
            },
            {
              value: 4,
            },
            {
              value: 4,
            },
            {
              value: 1,
            },
            {
              value: 1,
            },
            {
              value: 1,
            },
            {
              value: 1,
            },
            {
              value: 1,
            },
            {
              value: 1,
            },
            {
              value: 1,
            },
            {
              value: 1,
            },
            {
              value: 1,
            },
          ],
        },
        {
          productImage:
            'https://eu-images.contentstack.com/v3/assets/blt639569eaa143b45b/blt885b71b3dca45c5a/66a8bd76b3baaf4f6397e363/ultimate-x2.png',
          productName: 'ULTIMATE',
          productLink: '/produkte/reiniger/ultimate-spulmaschinentabs/54-regular/',
          color: 'black-gradient',
          values: [
            {
              value: 4,
            },
            {
              value: 4,
            },
            {
              value: 3,
            },
            {
              value: 1,
            },
            {
              value: 1,
            },
            {
              value: 1,
            },
            {
              value: 1,
            },
            {
              value: 1,
            },
            {
              value: 1,
            },
          ],
        },
        {
          productImage:
            'https://eu-images.contentstack.com/v3/assets/blt639569eaa143b45b/blt9a8d029b63113ce2/66a8bd75fb2f0f64f438eba8/quantum-x2.png',
          productName: 'QUANTUM',
          productLink: '/produkte/reiniger/quantum-spuelmaschinentabs/58-regular/',
          color: 'dark-blue-gradient',
          values: [
            {
              value: 3,
            },
            {
              value: 3,
            },
            {
              value: 2,
            },
            {
              value: 1,
            },
            {
              value: 1,
            },
            {
              value: 1,
            },
            {
              value: 1,
            },
            {
              value: 1,
            },
          ],
        },
        {
          productImage:
            'https://eu-images.contentstack.com/v3/assets/blt639569eaa143b45b/bltf7e1f373bd749614/66a8bd753d47313511294ec4/power-x2.png',
          productName: 'POWER',
          productLink: '/produkte/reiniger/power-spuelmaschinentabs/30-regular/',
          color: 'blue-gradient',
          values: [
            {
              value: 2,
            },
            {
              value: 2,
            },
            {
              value: 1,
            },
            {
              value: 1,
            },
            {
              value: 1,
            },
            {
              value: 1,
            },
          ],
        },
      ],
    },
  ],
};

export const FinishProductCardsMock = {
  cards: [
    {
      productName: 'LíQUIDO LIMPIAMÁQUINAS LAVAVAJILLAS</br> FINISH ®',
      image:
        'https://eu-images.contentstack.com/v3/assets/blt4dde3b0988d0aae1/blt3ea88fa76f69fe69/68b5706525a3b706b99235c6/Render_Finish_Limpiamaquinas_2024_FRENTE.png',
      cardStyle: 'finish-light-blue',
      button: {
        link: 'productos/aditivos/limpiador-de-lavavajillas/250ml/',
        text: 'Conoce más',
      },
      icons: [
        {
          src: 'https://eu-images.contentstack.com/v3/assets/blt4dde3b0988d0aae1/bltce2a71751fc1f0a1/6762a727712ba541f8306667/Clock.white.png',
          name: 'Mantenimiento mensual a tu lavavajillas',
        },
        {
          src: 'https://eu-images.contentstack.com/v3/assets/blt4dde3b0988d0aae1/blt9cf6bb0379680a7a/6762a756ac78dc5da104a3dd/shield.white.png',
          name: 'Lavavajillas Higiénico',
        },
        {
          src: 'https://eu-images.contentstack.com/v3/assets/blt4dde3b0988d0aae1/blt9a6499c9f60fd656/6762a756f1f2cb7681984357/Circle.white.png',
          name: 'Limpieza efectiva: Remoción de grasa y sarro',
        },
      ],
      mobileOrder: 2,
    },
    {
      productName: 'DETERGENTE EN TABLETAS FINISH ® QUANTUM',
      primary: true,
      image:
        'https://eu-images.contentstack.com/v3/assets/blt4dde3b0988d0aae1/blt1e724f5e283c9213/6859471d7f83817c62719cbe/Quantum_All_in_1.png',
      cardStyle: 'finish-grey',
      button: {
        link: '/productos/detergentes/tabletas/quantum-all-in-one/15-regular/',
        text: 'Conoce más',
      },
      icons: [
        {
          src: 'https://eu-images.contentstack.com/v3/assets/blt4dde3b0988d0aae1/blt325f8c2fab0862d7/6762a756bfd5c6db1610d332/Diamont.white.png',
          name: 'Sin necesidad de pre-lavar',
        },
        {
          src: 'https://eu-images.contentstack.com/v3/assets/blt4dde3b0988d0aae1/blt9cf6bb0379680a7a/6762a756ac78dc5da104a3dd/shield.white.png',
          name: 'Limpieza diaria',
        },
        {
          src: 'https://eu-images.contentstack.com/v3/assets/blt4dde3b0988d0aae1/blt9a6499c9f60fd656/6762a756f1f2cb7681984357/Circle.white.png',
          name: 'Remueve grasa y residuos difíciles',
        },
      ],
      mobileOrder: 1,
    },
    {
      productName: 'ABRILLANTADOR FINISH ®',
      image:
        'https://eu-images.contentstack.com/v3/assets/blt4dde3b0988d0aae1/blt89a6324f20953f4f/685949faa316b421c1a72b12/Abrillantador_Finish.png',
      cardStyle: 'finish-dark-blue',
      button: {
        link: '/productos/aditivos/abrillantador/400ml-regular/',
        text: 'Conoce más',
      },
      icons: [
        {
          src: 'https://eu-images.contentstack.com/v3/assets/blt4dde3b0988d0aae1/blt9a6499c9f60fd656/6762a756f1f2cb7681984357/Circle.white.png',
          name: 'mejor secado<sup>*</sup>',
        },
        {
          src: 'https://eu-images.contentstack.com/v3/assets/blt4dde3b0988d0aae1/blt9cf6bb0379680a7a/6762a756ac78dc5da104a3dd/shield.white.png',
          name: 'Protección contra la opacidad',
        },
        {
          src: 'https://eu-images.contentstack.com/v3/assets/blt4dde3b0988d0aae1/bltab1c439714d44c20/6762a756828566ed5471522b/Shine.white.png',
          name: 'Brillo resplandeciente',
        },
      ],
      mobileOrder: 3,
    },
  ],
};

export const FinishNewsletterPopupMock: FinishNewsletterPopupProps = {
  headline: 'NICHTS MEHR VERPASSEN',
  description:
    'Melden Sie sich über das folgende Formular für den Finish Newsletter an und bleiben Sie immer auf dem neuesten Stand rund um Finish! Mit betätigen des ANMELDEN-Buttons willigen Sie ein, von RB Hygiene Home Deutschland GmbH Informationen zu aktuellen Angeboten, Aktionen und anderen Neuigkeiten zur Finish Marke per E-Mail zu erhalten.',
  image: {
    src: 'https://eu-images.contentstack.com/v3/assets/bltf66eb2ba30842434/blt7512496341f5a468/66f53c689441d6ee01fe1a7d/newsletter_popup_image.png',
    mobileSrc:
      'https://eu-images.contentstack.com/v3/assets/bltf66eb2ba30842434/blt63c4941b86e10813/66f53c833097ebb254ddd0d8/newsletter_popup_image_mobile.png',
    alt: 'finish',
  },
  thankYou: {
    headline: 'VIELEN DANK FÜR IHRE ANMELDUNG FÜR DEN FINISH NEWSLETTER!',
    description: '',
    closeButton: {
      label: 'schließen',
      redirectUrl: '/',
    },
  },
  form: {
    id: '7f4311c4-00e3-48f9-a9cb-13b20ef2b28f',
    url: 'https://phx-promoplatform-api-pl-prod.promoplatform.rbcloud.io/api/v1/external/forms',
    submitErrorMessage: 'Bitte füllen Sie die erforderlichen Felder aus.',
  },
};
